import { render, staticRenderFns } from "./com_judge.vue?vue&type=template&id=a1d1ad32&scoped=true&"
import script from "./com_judge.vue?vue&type=script&lang=js&"
export * from "./com_judge.vue?vue&type=script&lang=js&"
import style0 from "./com_judge.vue?vue&type=style&index=0&id=a1d1ad32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d1ad32",
  null
  
)

export default component.exports